import SafeHtmlContent from "../SafeHtmlContent";

const DescriptionBlock = ({ description }) => {
  if (!description) return null;
  return (
    <div className="rounded-2xl border border-base-content/10 bg-base-200 p-6 shadow-sm">
      <p className="text-blue-500 text-xs font-bold tracking-wider uppercase mb-5">
        Biografi
      </p>
      <article className="max-w-none text-stone-300 leading-relaxed text-sm sm:text-base">
        <SafeHtmlContent
          html={description}
          className="prose prose-invert max-w-none"
        />
      </article>
    </div>
  );
};

export default DescriptionBlock;
